
<script>
  import CTA from "./CTA.svelte"
</script>

<div class="flex w-full items-center justify-betwen py-4 px-2">
  <CTA image="img/doggo.jpg" title={"Prescription Glasses"} copy={""}/>
  <CTA image="img/sundog.jpg" title={"Sun Glasses"} copy={""}/>
  <CTA image="img/readingdog.jpg" title={"Reading Glasses"} copy={""}/>
</div>